import { render } from "./CustomOverlay.vue?vue&type=template&id=07a73658"
import script from "./CustomOverlay.vue?vue&type=script&lang=js"
export * from "./CustomOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__